import { UserCard } from '../Card';
import SearchInput from '../SearchInput';
import { connect } from 'react-redux'
import { signOut } from "../../actions"

import React, { useState } from 'react';
import {
  MdClearAll,
  MdExitToApp,
  MdHelp,
  MdInsertChart,
  MdMessage,
  MdNotificationsActive,
  MdNotificationsNone,
  MdPersonPin,
  MdSettingsApplications,
  MdQueuePlayNext,
} from 'react-icons/md';
import {
  Button,
  ListGroup,
  ListGroupItem,
  // NavbarToggler,
  Nav,
  Navbar,
  NavItem,
  NavLink,
  Popover,
  PopoverBody,
} from 'reactstrap';
import bn from '../../utils/bemnames';
import ChangePasswordForm from '../common/changepassword';

const bem = bn.create('header');

class Header extends React.Component {
  state = {
    isOpenNotificationPopover: false,
    isNotificationConfirmed: false,
    isOpenUserCardPopover: false,
    openChangePassword : false
  };

  toggleNotificationPopover = () => {
    this.setState({
      isOpenNotificationPopover: !this.state.isOpenNotificationPopover,
    });

    if (!this.state.isNotificationConfirmed) {
      this.setState({ isNotificationConfirmed: true });
    }
  };

  toggleUserCardPopover = () => {
    this.setState({
      isOpenUserCardPopover: !this.state.isOpenUserCardPopover,
    });
  };

  handleSidebarControlButton = event => {
    event.preventDefault();
    event.stopPropagation();

    document.querySelector('.cr-sidebar').classList.toggle('cr-sidebar--open');
  };

  handleSignOutClick = event => {
    event.preventDefault();
    this.props.signOut();
  }

  handleChangePassword = () =>{
    this.setState({...this.state, openChangePassword:true})
    //this.props.session.session.cognitoUser.changePassword()
  }

  render() {
    const { isNotificationConfirmed } = this.state;

    return (
      <Navbar dark expand className={bem.b('bg-dark')}>
         <Nav navbar className="mr-2">
          <Button outline onClick={this.handleSidebarControlButton}>
            <MdClearAll size={20} />
          </Button>
        </Nav>
        {/*<Nav navbar>
          <Button color="primary" className="mr-2">Create Order</Button>
          <SearchInput />
        </Nav> */}

        <Nav navbar className={bem.e('nav-right')}>
          {(this.props.session.isLoggedIn) ? (
            <NavItem>
              <NavLink id="Popover2" className="can-click">
                {this.props.session.session.user.name}
              </NavLink>
              <Popover
                placement="bottom-end"
                isOpen={this.state.isOpenUserCardPopover}
                toggle={this.toggleUserCardPopover}
                target="Popover2"
                className="p-0 border-0"
                style={{ minWidth: 250 }}
              >
                <PopoverBody className="p-0 border-light">
                  <UserCard
                    title={this.props.session.session.user.name}
                    subtitle={this.props.session.session.user.email}
                    text=""
                    className="border-light"
                  >
                    <ListGroup flush>
                      <ListGroupItem tag="button" action className="border-light">
                        <MdPersonPin /> Profile
                    </ListGroupItem>
                      <ListGroupItem tag="button" action className="border-light">
                        <MdMessage /> Messages
                    </ListGroupItem>
                      <ListGroupItem tag="button" action className="border-light">
                        <MdSettingsApplications /> Settings
                    </ListGroupItem>
                      
                      <ListGroupItem tag="button" action className="border-light" onClick={this.handleSignOutClick}>
                        <MdExitToApp /> Signout
                    </ListGroupItem>
                      <ListGroupItem tag="button" action className="border-light" onClick={this.handleChangePassword}>
                        <MdExitToApp /> Change Password
                    </ListGroupItem>
                    </ListGroup>
                  </UserCard>
                </PopoverBody>
              </Popover>
            </NavItem>
          ) : (<></>)}
        </Nav>
        <Nav><ChangePasswordForm  key={this.state.openChangePassword} isOpen={this.state.openChangePassword} close={()=> this.setState({...this.state, openChangePassword:false})}/></Nav>
      </Navbar>
      
    );
  }
}

const mapStateToProps = state => {
  return { session: state.session }
}



export default connect(mapStateToProps,{ signOut: signOut })(Header);
